var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEatDrinks = function SvgEatDrinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 63.39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.51 31.39 12.11.98a1.5 1.5 0 0 0-1.93-.89 1.5 1.5 0 0 0-.89 1.93L20.3 31.39h-.85L4.9 2.27a1.498 1.498 0 0 0-2.68 1.34l13.89 27.77H0c0 17.67 14.33 32 32 32s32-14.33 32-32H23.51Zm27.34 18.47c-5 5.11-11.7 7.92-18.85 7.92s-13.85-2.81-18.85-7.92a1.5 1.5 0 0 1 2.14-2.1c4.44 4.53 10.37 7.02 16.71 7.02s12.27-2.49 16.71-7.02a1.5 1.5 0 0 1 2.14 2.1"
  })));
};
export default SvgEatDrinks;